import React, { useState, useEffect } from 'react'
import propTypes from 'prop-types'
import { object, string } from 'yup';
import { CloseRoundedIcon, SearchIcon } from '../../../theme/icons'
import { Button } from '..';
import { useToasts } from '../../Toast';

let timeout = 0;

const searchSchema = object({
    search: string().matches(`^[a-zA-Z0-9@, ]*$`, "Special characters in search are not allowed")
});

export const Search = React.memo(({ value="", onChangeSearch, placeholderText, className, parentClassName, mainClassName, onFocus = () => null }) => {
    const { setToastMessage } = useToasts();
    const [searchTextValue, setSearchTextValue] = useState("");
    const [enableFocus, setEnableFocus] = useState(false)

    useEffect(() => {
        if (timeout) {
            clearTimeout(timeout)
        }
        timeout = setTimeout(() => {
            enableFocus && onChangeSearch(searchTextValue?.trimStart());
        }, 500);

        return () => clearTimeout(timeout);
        // eslint-disable-next-line
    }, [searchTextValue, enableFocus])

    const handleRemoveSearchText = (searchText) => {
        setSearchTextValue("");
        onChangeSearch("");
        setEnableFocus(false);
        onFocus(false);
        
    }

    useEffect(() => {
        setSearchTextValue(value)
    }, [value])

    const handleChangeSearch = async (e) => {
        try {
            const value = e.target.value?.trimStart() || "";
            const textValidate = await searchSchema.validate({ search: value });
            setSearchTextValue(textValidate?.search);
        } catch (error) { setToastMessage({ message: error?.message, variant: "error" }) }
    }

    const handleChangeFocus = () => {
        onFocus(true);
        setEnableFocus(true)
    }

    return (
        <div className={`flex justify-center bg-primary items-end ${mainClassName}`}>
            <div className={`w-full ${parentClassName}`}>
                <div
                    className={`delay-200 relative border bg-white border-secondary-300 hover:border-primary-400 focus-within:border-primary-400 rounded-3xl pt-2 pb-1.75 px-2.5 transition-all duration-300 ${className}`}>
                    <div className='flex items-center gap-3 h-4 text-secondary-300 hover:text-secondary-400 focus-within:text-secondary-400'>
                        <div className="  flex items-center">
                            <SearchIcon></SearchIcon>
                        </div>
                        <input onFocus={handleChangeFocus} type="text" onChange={handleChangeSearch} value={searchTextValue} id="search-text"
                            className={` w-full border-0 text-xs font-normal h-fit  p-0 delay-200 block bg-transparent outline-none focus-visible:border-transparent focus:border-transparent focus:ring-transparent pr-6   `}
                            autoComplete="off" placeholder={placeholderText} />
                        {!!searchTextValue?.length && <div className="inset-y-0 right-2.5 flex items-center">
                            <Button onClick={handleRemoveSearchText} variant="secondary" className="flex items-center justify-end p-0 h-fit w-fit gap-0 mr-0 bg-transparent border-0" icon={<CloseRoundedIcon width={20} height={20} />} text=" " />
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    )
})

Search.propTypes = {
    onChangeSearch: propTypes.func,
    placeholderText: propTypes.string,
    searchText: propTypes.string,
    className: propTypes.string,
    parentClassName: propTypes.string,
    mainClassName: propTypes.string
}

Search.defaultProps = {
    onChangeSearch: () => { },
    placeholderText: 'Search',
    searchText: '',
    className: "",
    parentClassName: "md:min-w-330",
    mainClassName: ""
}


